import axios from 'axios';
export const getOrganization = async (root, organization) => axios.get(`${root}/legacy/rbac/organization/${organization}`).then((response) => response.data);
//# sourceMappingURL=rbac.js.map